/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";
import {ApiTable} from "../components/table";
import {useAppDispatch, useAppSelector} from "../store";
import {openDrawer} from "../reducers/drawers-reducer";
import {Customer} from "../core/datamodel";
import {CustomButton} from "../components/buttons";
import {IconSet} from "../components/icons";

export default function CustomerListView(props: any) {
    const dispatch = useAppDispatch();

    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Kunden</Breadcrumb.Item>
            </Breadcrumb>

            <ApiTable
                title={<><IconSet type='customers'/> Kunden</>}
                id="Kunden"
                url="customers"
                reloadSignals={[useAppSelector(state => state.reloadSignals.customer)]}
                searchable
                clickable
                buttons={
                    <CustomButton
                        mode={'add'}
                        tooltip={"Neuen Kunde hinzufügen"}
                        onClick={() => dispatch(openDrawer({key: 'customer', object: new Customer({})}))}
                    />
                }
            />
        </>
    )
}